import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  HStack,
  Stack,
  Text,
} from "@chakra-ui/react"
import type { FC } from "react"
import MarkdownViewer from "@/common/components/MarkdownViewer"
import { EXTERNAL_ROUTES } from "@/common/constants/routes"
import ReportSection from "@/proposal/components/simulation/common/ReportSection"
import type { SimulationResultType } from "@/proposal/components/simulation/common/SimulationResultBadge"
import SimulationResultBadge from "@/proposal/components/simulation/common/SimulationResultBadge"
import { mapCheckStatusToSimulationResult } from "@/proposal/components/simulation/helpers/simulation"
import type { SeatbeltReport } from "@/tallyProposal/hooks/useProposalSimulation"

type Props = {
  result?: SimulationResultType
  checks: SeatbeltReport["checks"]
}
const SeatbeltReportSection: FC<Props> = ({ result, checks }) => {
  if (!checks || checks.length === 0) return null

  return (
    <ReportSection
      hasTransparentBackground
      learnMoreLink={{
        url: EXTERNAL_ROUTES.simulations.seatbelt(),
        label: "Learn more about Seatbelt",
      }}
      result={result}
      title="Seatbelt simulations"
    >
      <Stack bgColor="gray.50" pt={2} spacing={2}>
        {checks.map((check, idx) => (
          <Stack key={`check-${idx}`}>
            <AccordionItem
              bgColor="white"
              borderColor="gray.200"
              borderRadius="md"
              borderWidth="1px"
            >
              <AccordionButton
                _hover={{
                  borderRadius: "md",
                  backgroundColor: "gray.100",
                }}
                borderColor="gray.200"
                px={3}
                py={3}
              >
                <HStack justifyContent="space-between" width="100%">
                  <Text pr={4} textAlign="left">
                    {check.title}
                  </Text>
                  <HStack>
                    <SimulationResultBadge
                      result={mapCheckStatusToSimulationResult(check.status)}
                    />
                    <AccordionIcon />
                  </HStack>
                </HStack>
              </AccordionButton>

              <AccordionPanel p={2}>
                <Box borderLeftColor="gray.200" borderLeftWidth="3px" ml={1}>
                  <Text fontSize="sm" pl={4}>
                    {check.info.length > 0
                      ? check.info.map((info, infoIdx) => (
                          <MarkdownViewer
                            key={`info-${idx}-${infoIdx}`}
                            content={info}
                          />
                        ))
                      : null}

                    {check.info.length === 0 && check.details ? (
                      <MarkdownViewer content={check.details} />
                    ) : null}
                  </Text>
                </Box>
              </AccordionPanel>
            </AccordionItem>
          </Stack>
        ))}
      </Stack>
    </ReportSection>
  )
}

export default SeatbeltReportSection
